const checkIsTrainer = (record, trainerId) => {
  const isLeadTrainer = record?.leadTrainer?.selected === trainerId;
  const isAssistantTrainer = record?.assistantTrainer?.selected === trainerId;
  const isSupportTrainer = record?.supportTrainers?.selected.some(
    (trainer) => trainer === trainerId
  );
  const isTrainer = isLeadTrainer || isAssistantTrainer || isSupportTrainer;

  return { isLeadTrainer, isAssistantTrainer, isSupportTrainer, isTrainer };
};

module.exports = { checkIsTrainer };
